export const COLLECTIONTS = {
  CARD: 'CARD',
  CARD_APPLY: 'CARD_APPLY',
  ADBANNER: 'ADBANNER',
  USER: 'USER',
} as const;
